import { ViewTemplate, html } from '@microsoft/fast-element';
import type { CompanyApproval } from './company-approval';
import { sync } from '@genesislcap/foundation-utils';
import { GOVERNING_AGREEMENT } from '../../../utils';

export const CompanyApprovalTemplate: ViewTemplate<CompanyApproval> = html`
  <div class="company-grid-approval">
    <div>
      <zero-checkbox
        class="company-data-name"
        @click="${(x) => (x.isCompanyApproval = !x.isCompanyApproval)}"
        ?current-checked=${(x) => x?.isCompanyApproval}
      >
        ${(x) => x.getCompanyName()}
      </zero-checkbox>
    </div>

    <div class="${(x) => (x.isCheckedChanged ? '' : 'hidden')}">
      <zero-segmented-control
        appearance="secondary"
        orientation="horizontal"
        :value="${sync((x) => x.governingAgreement)}"
      >
        <zero-segmented-item value="${(x) => GOVERNING_AGREEMENT.EXISTING_ISDA_MASTER_AGREEMENT}">
          Existing ISDA Master Agreement
        </zero-segmented-item>
        <zero-segmented-item value="${(x) => GOVERNING_AGREEMENT.STANDALONE_VPPA}">
          Standalone VPPA
        </zero-segmented-item>
      </zero-segmented-control>
    </div>

    <div class="date-field ${(x) => (x.showDateChanged ? '' : 'hidden')}">
      <zero-text-field
        placeholder=""
        type="date"
        onkeydown="return false"
        placeholder="Enter Date..."
        :value="${sync((x) => x.effectiveDate)}"
      ></zero-text-field>
    </div>
  </div>
`;
